import React from 'react';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { LuQrCode } from 'react-icons/lu';
import { useColorModeValue } from '../../ui/color-mode';

const QrCountCard = ({ count, label, bgColor, iconColor }) => (
  <Box
    p={3}
    w="250px"
    bg={useColorModeValue('gray.50', 'gray.800')}
    borderRadius="md"
    border="1px solid"
    borderColor={useColorModeValue('gray.200', 'gray.600')}
    boxShadow="sm"
  >
    <Flex align="center" gap={3}>
      <Box
        p={2}
        bg={bgColor.light}
        borderRadius="md"
      >
        <Icon as={LuQrCode} boxSize={5} color={iconColor.light} />
      </Box>
      <Box>
        <Text fontSize="lg" fontWeight="bold" color={useColorModeValue('inherit', 'inherit')}>
          {count?.toLocaleString() || '0'}
        </Text>
        <Text fontSize="xs" color={useColorModeValue('gray.600', 'gray.400')}>
          {label}
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default QrCountCard;
